
import { Options, Vue } from 'vue-class-component'
import Farm from '@/farm/Farm'
import EmployeeCard from '@/components/EmployeeCard.vue'
import ValueMeter from '@/components/ui/ValueMeter.vue'
import util from '../../util'
import FarmStatusCard from '@/components/FarmStatusCard.vue'
import StatusBar from '@/components/StatusBar.vue'
import TextButton from '@/components/ui/TextButton.vue'
import EventsCard from '@/components/EventsCard.vue'
import OfficeTasksCard from '@/components/OfficeTasksCard.vue'
import SalesCard from "@/components/SalesCard.vue"

@Options({
  components: {
    OfficeTasksCard, EventsCard, SalesCard, ValueMeter, FarmStatusCard, StatusBar, TextButton
  },
  props: {
    farm: Object
  },
  emits: ['close'],
  methods: {
    log(msg: any) {
      console.log(msg)
    },
    util() {
      return util
    }
  },
  async created() {
    //let farm = new Farm()
    //await farm.load()
    //this.farm = farm
    this.isLoaded = true
  }
})
export default class OfficeView extends Vue {
  isLoaded = false
  farm!: Farm
}
